import React from 'react';
import {
  assetsPricing,
  pbPreferredPricing,
} from '../../../../../../constants/PricingBenefits';
import { LazyImage } from '../../../../../shared/LazyImage';
import { clickCta } from '../../../../../../utils/analytics';

export const Img = ({
  src,
  classes,
  width,
  height,
}: {
  src: string;
  classes?: string;
  width?: string | number;
  height?: string | number;
}) => (
  <img
    src={src}
    alt="img"
    width={width || 'auto'}
    height={height || 'auto'}
    className={`${classes || ''} sui-max-w-none`}
  />
);

export const VideoPP = ({
  noAutoPlay,
}: {
  noAutoPlay?: boolean;
}): JSX.Element => {
  return (
    <video width="730" height="auto" controls autoPlay={!noAutoPlay}>
      <source src={pbPreferredPricing.pricingVideo['720p']} type="video/mp4" />
    </video>
  );
};
export const ModalCloseIcon = ({
  setModal,
}: {
  setModal?: React.Dispatch<React.SetStateAction<boolean>>;
}): JSX.Element => (
  <button
    type="button"
    onClick={() => {
      if (setModal) {
        setModal(false);
      }
    }}
    data-testid="modalClose"
  >
    <img alt="img" src={assetsPricing.CloseIcon} width="auto" height="auto" />
  </button>
);
export const VideoLabelBtn = ({
  rounded,
}: {
  rounded: boolean;
}): JSX.Element => (
  <Img
    src={assetsPricing.videoPreferredPricingWithButton}
    classes={`sui-w-full sui-h-full ${rounded ? 'sui-rounded-md' : ''}`}
  />
);
export const VideoLabelPlayBtn = ({
  rounded,
  isDark,
  setModal,
}: {
  rounded: boolean;
  isDark?: boolean;
  setModal: React.Dispatch<React.SetStateAction<boolean>>;
}): JSX.Element => (
  <div className="sui-relative sui-mx-auto" style={{ maxWidth: '300px' }}>
    <div className="">
      <LazyImage
        src={assetsPricing.proXtraPreferredD}
        classes={`${rounded ? 'sui-rounded-md' : ''}`}
        altText="Top banner, Home Depot store"
        aria-label="image"
      />
    </div>
    <div className="sui-absolute sui-top-0 sui-right-0 sui-left-0 sui-bottom-0 sui-flex sui-justify-center">
      <button
        type="button"
        onClick={() => {
          setModal(true);
          clickCta(
            'pricing benefits: preferred pricing: hdiw overlay: video view',
          );
        }}
      >
        <LazyImage
          src={assetsPricing[isDark ? 'iconVideoPlayDark' : 'VideoLogowhite']}
          classes={`sui-h-full ${isDark ? 'sui-opacity-75' : ''}`}
          width="76"
          height="76"
          aria-label="image"
          altText="Top banner, Home Depot store"
        />
      </button>
    </div>
  </div>
);
export const VideoContainer = ({
  setModal,
  noAutoPlay,
}: {
  setModal: React.Dispatch<React.SetStateAction<boolean>>;
  noAutoPlay?: boolean;
}): JSX.Element => (
  <div className="sui-bg-inverse sui-h-full sui-px-4 sui-pb-4 sui-pt-1 sui-flex sui-justify-center sui-flex-col">
    <div className="sui-absolute sui-right-3 sui-top-3">
      <ModalCloseIcon setModal={setModal} />
    </div>
    <div className="sui-pt-3">
      <VideoPP noAutoPlay={noAutoPlay} />
    </div>
  </div>
);
